import { createElement, Component, Props as ReactProps } from 'react';
import { DependencyProps } from '../../core/dependency';
import { LocationProps } from '../../core/location';
import { StateProps } from '../../core/state';
import ConfirmSummary from '../components/organisms/ConfirmSummary';
import RootFrame from '../components/templates/RootFrame';
import Store from '../../entity/store';
import {
  Modal,
} from "antd";

type Props = ReactProps<HTMLDivElement> &
  DependencyProps &
  StateProps &
  LocationProps;

class ConfirmRoute extends Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    this.buy = this.buy.bind(this);
  }

  public componentWillMount() {
    this.initialize(this.props);
  }

  public componentWillUnmount() {
    this.dispose(this.props);
  }

  public render() {
    const { dependency, location, state } = this.props;
    const {
      order,
      orderProducts,
      products,
      fetches,
    } = state.confirm;
    const currentStore = state.currentStore;
    if (!currentStore) {
      return null;
    }

    const summaries = <ConfirmSummary
      order={order}
      products={products}
      orderProducts={orderProducts}
      onClickBuy={this.buy}
      store={currentStore}
    />;

    return <RootFrame
      {...{ dependency, location, state }}
      content={summaries}
      isSpinner={fetches === 1}
    />;
  }

  private async initialize(props: Props) {
    try {
      await props.dependency.confirm.initialize();
    } catch (err) {
      window.console.error(err);
    }
  }

  private async buy() {
    try {
      await this.props.dependency.confirm.buy();
      const store = this.props.state.currentStore as Store;
      window.location.href = store.completeUri;
    } catch (e) {
      if (e['graphQLErrors'] && e['graphQLErrors'][0].type) {
        Modal.error({
          title: '注文に失敗しました。',
          content: <div>入力内容を確認してください。</div>,
        });
      } else {
        Modal.error({
          title: '保存に失敗',
          content: <div>
            <div>保存に失敗しました。</div>
            <div>{e.message}</div>
          </div>,
        });
      }
    }
  }

  private dispose(props: Props) {
    try {
      props.dependency.confirm.dispose();
    } catch (err) {
      window.console.error(err);
    }
  }
}

export default ConfirmRoute;
